import { render, staticRenderFns } from "./PricePanelTypeEditForm.vue?vue&type=template&id=875fe2f6"
import script from "./PricePanelTypeEditForm.vue?vue&type=script&lang=js"
export * from "./PricePanelTypeEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports